import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from './components/Navbar';
import { useTheme } from "./context/ThemeContext";
import Sidebar from './components/Sidebar';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './router/AppRouters.jsx';


function App() {
  const { theme } = useTheme();
  return ( 
    <BrowserRouter>
      <div className={`App ${theme}`}>
        <Navbar />
        <div className="main-container">
          <Sidebar />
          <main className="main-content">
            <AppRoutes />  {/* other routers are called from here  */}
          </main>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
